import React from "react";

const WorkDetails = ({
  newEmployee,
  setNewEmployee,
  departments,
  designations,
  managers,
  employeeTypes,
}) => {
  return (
    <>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Department</label>
          <select
            className="form-select"
            value={newEmployee.department || ""}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, department: e.target.value })
            }
            required
          >
            <option value="" disabled>
              Select Department
            </option>
            {departments.map((dept) => (
              <option key={dept.department_id} value={dept.department_name}>
                {dept.department_name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label>Date of Joining</label>
          <input
            type="date"
            className="form-control"
            value={newEmployee.date_of_join || ""}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, date_of_join: e.target.value })
            }
            required
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-4">
          <label>Designation</label>
          <select
            className="form-select"
            value={newEmployee.designation || ""}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, designation: e.target.value })
            }
            required
          >
            <option value="" disabled>
              Select Designation
            </option>
            {designations.map((d) => (
              <option key={d.id} value={d.id}>
                {d.designation_name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label>Manager</label>
          <select
            className="form-select"
            value={newEmployee.manager || ""}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, manager: e.target.value })
            }
            required
          >
            <option value="" disabled>
              Select Manager
            </option>
            {managers.map((m) => (
              <option
                key={m.user_id}
                value={`${m.first_name} ${m.last_name}`}
              >
                {m.first_name.charAt(0).toUpperCase() +
                  m.first_name.slice(1)}{" "}
                {m.last_name.charAt(0).toUpperCase() + m.last_name.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label>Employee Type</label>
          <select
            className="form-select"
            value={newEmployee.employee_type || ""}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, employee_type: e.target.value })
            }
            required
          >
            <option value="" disabled>
              Select Employee Type
            </option>
            {employeeTypes.map((type) => (
              <option key={type.id} value={type.type}>
                {type.type}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
};

export default WorkDetails;
